import { useCallback } from 'react';
import { usePostHog } from '@posthog/react';
import type { WizardStep } from '../components/PnidWizardSidebar';

/**
 * Returns a `trackAction` helper that auto-attaches the current step context
 * (step number, step name, diagram ID) to every PostHog event.
 */
export function useActionTracker(
  wizardStep: WizardStep,
  diagramId: string | null,
  stepLabels: Record<WizardStep, string>,
) {
  const posthog = usePostHog();

  const trackAction = useCallback(
    (event: string, props?: Record<string, unknown>) => {
      posthog?.capture(event, {
        step_number: wizardStep,
        step_name: stepLabels[wizardStep],
        diagram_id: diagramId,
        ...props,
      });
    },
    [posthog, wizardStep, diagramId, stepLabels],
  );

  return { trackAction };
}
